import { createFileRoute } from "@tanstack/solid-router";

export const Route = createFileRoute("/error")({

  component: RouteComponent,
});
function RouteComponent() {
	return (
		<div class="p-4">
			<button
				type="button"
				onClick={() => {
					throw new Error("Sentry Frontend Errorrr");
				}}
			>
				Throw error
			</button>
		</div>
	);
}
